import * as React from 'react'
import { getLang } from '../helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import {
  buildImageSrcSet,
  getImageFallbackUrls,
  resolveImageAlt,
  selectImageSource,
} from '../utils/responsiveImage'
import Dialog from './Dialog'
import Markdown from './Markdown'

const HotelDialog: React.FunctionComponent = () => {
  const language = useBookingFormStore((state) => state.language)
  const setHotelDialogData = useBookingFormStore((state) => state.setHotelDialogData)
  const hotelDialog = useBookingFormStore((state) => state.hotelDialog)

  const { data } = hotelDialog
  const imageSrcSet = buildImageSrcSet(data?.variants)

  return (
    <Dialog
      imageAlt={resolveImageAlt(data?.alt, language, data?.name || '')}
      imageFallbackUrls={getImageFallbackUrls(data?.thumbnail, data?.image)}
      imageHeight={data?.height}
      imageSizes="(min-width: 768px) 704px, calc(100vw - 96px)"
      imageSrcSet={imageSrcSet}
      imageUrl={selectImageSource(data?.variants, data?.thumbnail, data?.image)}
      imageWidth={data?.width}
      onClose={() => setHotelDialogData(null)}
      open={Boolean(data)}
      title={data?.name || ''}
    >
      <Markdown source={getLang(data?.description, language) || ''} />
    </Dialog>
  )
}

export default HotelDialog
